import moment from 'moment'
import { Views } from 'react-big-calendar'

interface IUseGetStartEndDate {
  start_date: string
  end_date: string
}

export default function UseGetStartEndDate(inputDate?: Date): IUseGetStartEndDate {
  const view: string = Views.MONTH
  const date = inputDate ?? new Date()
  let start_date = ''
  let end_date = ''
  if (view === 'day') {
    start_date = moment(date).startOf('day').toISOString()
    end_date = moment(new Date()).endOf('day').toISOString()
  } else if (view === 'week') {
    start_date = moment(date).startOf('week').toISOString()
    end_date = moment(date).endOf('week').toISOString()
  } else if (view === 'month') {
    start_date = moment(date).startOf('month').subtract(5, 'days').toISOString()
    end_date = moment(date).endOf('month').add(5, 'days').toISOString()
  }
  return { start_date, end_date }
}
